// src/components/PendingInviteBanner.jsx
// Banner hiển thị lời mời đang chờ ở đầu dashboard

import { useInvites } from "../hooks/useInvites";
import toast from "react-hot-toast";
import "../styles/invite.css";

export default function PendingInviteBanner({ onAccepted }) {
  const { pendingInvites, acceptInvite, declineInvite } = useInvites();

  if (pendingInvites.length === 0) return null;

  const handleAccept = async (invite) => {
    try {
      await acceptInvite(invite);
      toast.success(`Đã tham gia workspace "${invite.workspaceName}"!`);
      onAccepted?.(invite.workspaceId);
    } catch {
      toast.error("Có lỗi xảy ra, thử lại nhé.");
    }
  };

  const handleDecline = async (invite) => {
    await declineInvite(invite.id);
    toast("Đã từ chối lời mời.", { icon: "👋" });
  };

  return (
    <div className="invite-banner-list">
      {pendingInvites.map((invite) => (
        <div key={invite.id} className="invite-banner">
          <div className="invite-banner-icon">✉️</div>
          <div className="invite-banner-text">
            <strong>{invite.fromName}</strong> mời bạn vào workspace{" "}
            <strong>"{invite.workspaceName}"</strong>
          </div>
          <div className="invite-banner-actions">
            <button
              className="invite-accept-btn"
              onClick={() => handleAccept(invite)}
            >
              Chấp nhận
            </button>
            <button
              className="invite-decline-btn"
              onClick={() => handleDecline(invite)}
            >
              Từ chối
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
